export default "__VITE_ASSET__PVeNmLgU__"